import styled from "@emotion/styled";
import { PageLoaderDuration } from "provider";
import { Link, NavLink } from "react-router-dom";

export const Container = styled.div`
  background: #fff;
  height: 100%;
`;
export const CustomLink = styled(Link)`
  text-decoration: none;
  color: var(--black);
  font-weight: 400;
  transition: 0.2s ease;
  font-size: 0.92rem;
  font-family: "Inter", serif;
  &:hover {
    opacity: 70%;
  }
`;

export const CustomNavLink = styled(NavLink)`
  text-decoration: none;
  color: #fff;
  font-weight: 400;
  transition: 0.2s ease;
  font-size: 0.82rem;
  &:hover {
    opacity: 80%;
  }
`;

export const CustomOTPInput = styled.div`
  div {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .otp-input {
    width: 100% !important;
    height: 3.5em;
    border-radius: 8px;
    border: 1px solid #c4c4c4;
    font-size: 16px;

    &:focus {
      outline: none;
      border-color: #fce300;
    }
  }
`;

export const CustomRadioGroup = styled.div`
  .MuiFormLabel-root {
    font-size: 0.75rem;
  }

  .MuiFormControlLabel-label {
    font-size: 0.8rem;
  }
`;

export const CustomPhoneInput = styled.div`
  .MuiFormControl-root {
    width: 100%;
  }

  // .MuiFormLabel-root {
  //   font-size: .75rem;
  //   margin-bottom: 10px;
  // }

  .react-tel-input {
    font-family: "Poppins", sans-serif !important;
    margin-top: 24px;
  }

  .react-tel-input .form-control {
    position: relative;
    border: 1px solid;
    font-size: 0.875rem;
    font-weight: 600;
    width: 100%;
    padding: 12px 12px 12px 58px;
    border-color: #c4c4c4;
    border-radius: 4px;
    margin: 0;
  }

  .react-tel-input .form-control:hover {
    border-color: #c4c4c4;
  }

  .react-tel-input .form-control:focus {
    border-color: #000;
    box-shadow: none;
  }

  .react-tel-input .form-control::placeholder {
    color: #c4c4c4;
  }

  .react-tel-input .form-control:focus + div:before {
    color: #fce300;
  }

  .react-tel-input .form-control:focus + label.MuiFormLabel-root {
    color: #202020 !important;
  }
`;

export const CustomCurrencyInput = styled.div`
  width: 100%;
  position: relative;

  .MuiInputBase-root {
    margin-top: 0;
  }

  .MuiFormControl-root {
    width: 100%;
  }

  .MuiFormLabel-root {
    font-size: 0.75rem;
    margin-bottom: 10px;
  }

  #currency-input {
    padding-left: 72px;
    position: relative;
  }
`;

export const CurrencyWrapper = styled.div`
  .menu-flags {
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 0;
    z-index: 2;
    height: 45px;
  }

  .menu-flags,
  .menu-flags:focus {
    outline: none;
    border: none;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  }
`;

export const CustomCarousel = styled.div`
  .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
  }

  .swiper-slide img {
    display: block;
    width: 350px;
  }

  .swiper-button-prev {
    right: 12.4rem !important;
  }

  .swiper-button-next {
    right: 10.4rem !important;
  }

  .swiper-button-prev:after,
  .swiper-button-next:after {
    transform: scale(0.3);
  }

  .swiper-button-prev,
  .swiper-button-next {
    color: #fff;
    padding: 0 0.4rem;
    background: #000;
    position: absolute;
    bottom: 0 !important;
    top: 67.8%;
    left: auto;
  }
`;

export const CustomLoader = styled.div`
  .loading-spinner,
  .loader-bg {
    position: fixed;
    height: 100vh;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999;
    background-color: transparent;
    text-align: center;
    padding: 20px;
    height: fit-content;

    .loader-text {
      display: block;
      font-size: 14px;
      color: var(--primary);
    }
  }

  .backdrop {
    position: fixed;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.9);
    z-index: 98;
  }
  .logo-loader.animate {
    svg {
      animation: logo-beep 1s ease-in-out infinite;
    }
  }
  .logo-loader {
    display: inline-block;
    position: relative;
    span {
      height: 5.156px;
      display: block;
      position: absolute;
      top: 16.7px;
      left: 29px;
      background: #ed1c24;
      width: 100%;
    }
    span:first-of-type {
      top: 35.04px;
    }
  }

  @keyframes logo-beep {
    0% {
      
      transform: scale(1);
      opacity: 1;
    }

    50% {
      
      transform: scale(1.1);
      opacity: 0.7;
    }

    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .la-square-loader {
    display: inline-block;
    position: relative;
    width: 60px;
    height: 60px;
    color: var(--primary);
  }

  .la-square-loader > div:first-of-type {
    width: 44px;
    height: 44px;
  }
`;

export const CustomSpinner = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s linear;

  span {
    // background: url();
    background-repeat: no-repeat;
    background-position: center;
    background-size: 50%;
    position: relative;
    width: 100px;
    height: 100px;
  }

  span:before,
  span:after {
    content: "";
    border-radius: 50%;
    position: absolute;
    inset: 0;
    box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.1) inset;
  }
  span:after {
    box-shadow: 0 2px 0 ${({ color = "#ff3d00" }) => color} inset;
    animation: rotate 2s linear infinite;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const CustomNetworkLoader = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s linear;
  span {
    position: relative;
    width: 75px;
    height: 100px;
    background-repeat: no-repeat;
    background-image: linear-gradient(#ddd 50px, transparent 0),
      linear-gradient(#ddd 50px, transparent 0),
      linear-gradient(#ddd 50px, transparent 0),
      linear-gradient(#ddd 50px, transparent 0),
      linear-gradient(#ddd 50px, transparent 0);
    background-size: 8px 100%;
    background-position: 0px 90px, 15px 78px, 30px 66px, 45px 58px, 60px 50px;
    animation: pillerPushUp 4s linear infinite;
  }
  span:after {
    content: "";
    position: absolute;
    bottom: 10px;
    left: 0;
    width: 10px;
    height: 10px;
    background: #de3500;
    border-radius: 50%;
    animation: ballStepUp 4s linear infinite;
  }

  @keyframes pillerPushUp {
    0%,
    40%,
    100% {
      background-position: 0px 90px, 15px 78px, 30px 66px, 45px 58px, 60px 50px;
    }
    50%,
    90% {
      background-position: 0px 50px, 15px 58px, 30px 66px, 45px 78px, 60px 90px;
    }
  }

  @keyframes ballStepUp {
    0% {
      transform: translate(0, 0);
    }
    5% {
      transform: translate(8px, -14px);
    }
    10% {
      transform: translate(15px, -10px);
    }
    17% {
      transform: translate(23px, -24px);
    }
    20% {
      transform: translate(30px, -20px);
    }
    27% {
      transform: translate(38px, -34px);
    }
    30% {
      transform: translate(45px, -30px);
    }
    37% {
      transform: translate(53px, -44px);
    }
    40% {
      transform: translate(60px, -40px);
    }
    50% {
      transform: translate(60px, 0);
    }
    57% {
      transform: translate(53px, -14px);
    }
    60% {
      transform: translate(45px, -10px);
    }
    67% {
      transform: translate(37px, -24px);
    }
    70% {
      transform: translate(30px, -20px);
    }
    77% {
      transform: translate(22px, -34px);
    }
    80% {
      transform: translate(15px, -30px);
    }
    87% {
      transform: translate(7px, -44px);
    }
    90% {
      transform: translate(0, -40px);
    }
    100% {
      transform: translate(0, 0);
    }
  }
`;
export const CustomProgressBar = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s linear;
  span {
    width: 0;
    height: 4.8px;
    display: inline-block;
    position: relative;
    background: #fff;
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    box-sizing: border-box;
    animation: animFw 8s linear infinite;
  }
  span::after,
  span::before {
    content: "";
    width: 10px;
    height: 1px;
    background: #fff;
    position: absolute;
    top: 9px;
    right: -2px;
    opacity: 0;
    transform: rotate(-45deg) translateX(0px);
    box-sizing: border-box;
    animation: coli1 0.3s linear infinite;
  }
  span::before {
    top: -4px;
    transform: rotate(45deg);
    animation: coli2 0.3s linear infinite;
  }

  @keyframes animFw {
    0% {
      width: 0;
    }
    100% {
      width: 100%;
    }
  }

  @keyframes coli1 {
    0% {
      transform: rotate(-45deg) translateX(0px);
      opacity: 0.7;
    }
    100% {
      transform: rotate(-45deg) translateX(-45px);
      opacity: 0;
    }
  }

  @keyframes coli2 {
    0% {
      transform: rotate(45deg) translateX(0px);
      opacity: 1;
    }
    100% {
      transform: rotate(45deg) translateX(-45px);
      opacity: 0.7;
    }
  }
`;

export const CustomLightLoader = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s linear;
  span {
    width: 4px;
    height: 86px;
    background: #fff;
    margin: auto;
    position: relative;
    animation: shake 1s linear infinite alternate, lightup 1s linear infinite;
    transform-origin: 0 0;
  }

  span::before {
    content: "";
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translateX(-50%);
    width: 32px;
    height: 16px;
    box-sizing: border-box;
    border: 5px solid #ff3d00;
    border-top: none;
    border-radius: 0 0 20px 20px;
  }
  span::after {
    content: "";
    left: 50%;
    bottom: 0;
    position: absolute;
    transform: translateX(-50%);
    width: 64px;
    height: 32px;
    border-radius: 50px 50px 0 0;
    background: #fff;
  }

  @keyframes shake {
    0% {
      transform: rotate(10deg);
    }
    100% {
      transform: rotate(-10deg);
    }
  }
  @keyframes lightup {
    0%,
    20%,
    40% {
      opacity: 0;
    }
    10%,
    30%,
    50%,
    100% {
      opacity: 1;
    }
  }
`;

export const CustomHourGlassLoader = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s linear;
  span {
    box-sizing: border-box;
    display: inline-block;
    width: 50px;
    height: 80px;
    border-top: 5px solid #fff;
    border-bottom: 5px solid #fff;
    position: relative;
    background: linear-gradient(#ff3d00 30px, transparent 0) no-repeat;
    background-size: 2px 40px;
    background-position: 50% 0px;
    animation: spinx 5s linear infinite;
  }
  span:before,
  span:after {
    content: "";
    width: 40px;
    left: 50%;
    height: 35px;
    position: absolute;
    top: 0;
    transform: translatex(-50%);
    background: rgba(255, 255, 255, 0.4);
    border-radius: 0 0 20px 20px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 0 0px;
    animation: lqt 5s linear infinite;
  }
  span:after {
    top: auto;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    animation: lqb 5s linear infinite;
  }
  @keyframes lqt {
    0%,
    100% {
      background-image: linear-gradient(#ff3d00 40px, transparent 0);
      background-position: 0% 0px;
    }
    50% {
      background-image: linear-gradient(#ff3d00 40px, transparent 0);
      background-position: 0% 40px;
    }
    50.1% {
      background-image: linear-gradient(#ff3d00 40px, transparent 0);
      background-position: 0% -40px;
    }
  }
  @keyframes lqb {
    0% {
      background-image: linear-gradient(#ff3d00 40px, transparent 0);
      background-position: 0 40px;
    }
    100% {
      background-image: linear-gradient(#ff3d00 40px, transparent 0);
      background-position: 0 -40px;
    }
  }
  @keyframes spinx {
    0%,
    49% {
      transform: rotate(0deg);
      background-position: 50% 36px;
    }
    51%,
    98% {
      transform: rotate(180deg);
      background-position: 50% 4px;
    }
    100% {
      transform: rotate(360deg);
      background-position: 50% 36px;
    }
  }
`;

export const CustomEyesLoader = styled.div`
  padding: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s linear;
  span {
    position: relative;
    width: 108px;
    display: flex;
    justify-content: space-between;
  }
  span::after,
  span::before {
    content: "";
    display: inline-block;
    width: 48px;
    height: 48px;
    background-color: #fff;
    background-image: radial-gradient(circle 14px, #0d161b 100%, transparent 0);
    background-repeat: no-repeat;
    border-radius: 50%;
    animation: eyeMove 10s infinite, blink 10s infinite;
  }
  @keyframes eyeMove {
    0%,
    10% {
      background-position: 0px 0px;
    }
    13%,
    40% {
      background-position: -15px 0px;
    }
    43%,
    70% {
      background-position: 15px 0px;
    }
    73%,
    90% {
      background-position: 0px 15px;
    }
    93%,
    100% {
      background-position: 0px 0px;
    }
  }
  @keyframes blink {
    0%,
    10%,
    12%,
    20%,
    22%,
    40%,
    42%,
    60%,
    62%,
    70%,
    72%,
    90%,
    92%,
    98%,
    100% {
      height: 48px;
    }
    11%,
    21%,
    41%,
    61%,
    71%,
    91%,
    99% {
      height: 18px;
    }
  }
`;

export const CustomPasswordChecklist = styled.div`
  ul {
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-rows: 1fr;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 0px 0px;
    grid-template-areas:
      "li li"
      "li li";
  }
  li {
    align-items: center !important;
  }
  li img {
    margin-right: 5px;
  }
  li span {
    font-size: 12px;
  }
`;

export const CustomTag = styled.div`
  height: 32px;
  padding: 0px 8px 0px 12px;
  white-space: nowrap;
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
  border-radius: 4px;
  border: 0.6px dashed #00b2a9;
  background: #f4fffe;
  color: #00b2a9;
`;

export const PulseLiveIcon = styled.div`
  position: relative;
  // left: 50%;
  // top: 50%;
  // transform: translateX(-50%) translateY(-50%);
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-left: 10px;
  margin-right: 10px;
  &:before {
    content: "";
    position: relative;
    display: block;
    width: 250%;
    height: 250%;
    box-sizing: border-box;
    // margin-left: 75%;
    // margin-top: -75%;
    border-radius: 50%;
    top: -75%;
    left: -75%;
    background-color: red;
    animation: pulse 1.25s cubic-bezier(0.215, 0.61, 0.355, 1) infinite;
  }

  &:after {
    content: "";
    position: absolute;
    // left: 50%;
    top: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-color: red;
    border-radius: 50%;
    animation: circle 1.25s cubic-bezier(0.455, 0.03, 0.515, 0.955) -0.4s infinite;
  }

  @keyframes pulse {
    0% {
      transform: scale(0.33);
    }
    80%,
    100% {
      opacity: 0;
    }
  }

  @keyframes circle {
    0% {
      transform: scale(0.8);
    }
    50% {
      transform: scale(1);
    }
    100% {
      transform: scale(0.8);
    }
  }
`;
